import { useMovableInkCampaignContext } from 'modules/movableInk/contexts/MovableInkCampaignContext';
import { useMovableInkIntegrationContext } from 'modules/movableInk/contexts/MovableInkIntegrationContext';
import { usePanelContext } from 'modules/movableInk/contexts/Panel';
import { useCallback, useMemo } from 'react';
import { BaseOption } from 'ui/selectv2/types';

export const useChildIntegrationOptionsState = () => {
  const { childIntegrations, isFetchingChildIntegrations, setCurrentCompanyId, currentCompanyId } =
    useMovableInkIntegrationContext();
  const { setCampaignId } = useMovableInkCampaignContext();
  const { setPanelSearch } = usePanelContext();

  const options = useMemo(() => {
    return childIntegrations.map(({ name, companyId }) => ({
      label: name,
      value: companyId.toString(),
    }));
  }, [childIntegrations]);

  const onSelect = useCallback(
    ([{ value }]: BaseOption<string>[]) => {
      const intId = parseInt(value, 10);
      const childIntegration = childIntegrations.find(({ companyId }) => intId === companyId);
      if (childIntegration) {
        setCurrentCompanyId(childIntegration.companyId);
        setCampaignId();
        setPanelSearch('');
      }
    },
    [childIntegrations, setCurrentCompanyId, setCampaignId, setPanelSearch],
  );

  const selectedOption = useMemo(() => {
    if (!currentCompanyId) return [];
    const stringId = currentCompanyId.toString();
    const option = options.find(({ value }) => value === stringId);
    return option ? [option] : [];
  }, [options, currentCompanyId]);

  const isDisabled = useMemo(
    () => !isFetchingChildIntegrations && childIntegrations.length === 0,
    [isFetchingChildIntegrations, childIntegrations],
  );

  const hasMultipleChildIntegrations = childIntegrations.length > 1;

  return {
    selectedOption,
    isDisabled,
    onSelect,
    options,
    isLoading: isFetchingChildIntegrations,
    hasMultipleChildIntegrations,
  };
};
